var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ opened: _vm.rootSideOpened, 'side-opened': _vm.sideOpened },attrs:{"id":"root-side"}},[_c('Globals'),_c('h3',[_vm._v(_vm._s(_vm.$t('song.playlists')))]),_c('Playlists'),_c('h3',[_vm._v(_vm._s(_vm.$t('song.authors')))]),_c('Authors'),_c('br'),_c('br'),_c('br')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }